import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {MatMenuTrigger} from "@angular/material/menu";
import {Observable, switchMap} from "rxjs";
import {Actions, ofType} from "@ngrx/effects";
import {closeNotificationMenu} from "./notification-center.actions";
import {tap} from "rxjs/operators";
import {TypedAction} from "@ngrx/store/src/models";

@Injectable()
export class NotificationCenterStore extends ComponentStore<any> {

  public initClose = this.effect((menu$: Observable<MatMenuTrigger>) => menu$.pipe(
    switchMap((menu: MatMenuTrigger): Observable<TypedAction<string>> => this._actions$.pipe(
      ofType(closeNotificationMenu),
      tap((): void => {
        menu.closeMenu();
      })
    ))
  ));

  constructor(
    private readonly _actions$: Actions
  ) {
    super({});
  }
}
